export async function sendSlackNotification({ message, chanelID }) {
  try {
    const response = await fetch(
      "https://us-central1-auto-clupp.cloudfunctions.net/cluppAdminAPI/slack/slackMessage",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          channel: chanelID,
          text: message,
        }),
      }
    );

    if (!response.ok) {
      throw new Error(
        `Error sending Slack notification: ${response.statusText}`
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error sending Slack notification: ${error}`);
  }
}

export default sendSlackNotification;
